import dayjs from 'dayjs'
import { DAY_OF_WEEK } from 'components/phone-availibility/constants'

/**
 * Check if a given date is a weekend (Saturday or Sunday).
 * @param {dayjs.ConfigType} d
 * @returns {boolean}
 */
export const isWeekend = (d?: dayjs.ConfigType): boolean => {
  const date = d ? dayjs(d) : dayjs()
  return date.day() === DAY_OF_WEEK.saturday || date.day() === DAY_OF_WEEK.sunday
}
